import { useEffect, useState } from "react";
import { get } from "lodash";
import Poller from "@tvg/poller";
import uamService from "@tvg/api/uam";
import { handleErrorModalRegistrationAction } from "../actions";
import { onfidoPollerCallback } from "../utils/handlers";

const POLLER_INTERVAL = 3000;
const POLLER_EXTENDED_INTERVAL = 10000;
const COUNTER_INCREMENT = 3000;
const COUNTER_CHECK = 30000;
let counter = 0;
const checksPoller = new Poller();

export default ({
  dispatch,
  showOnfidoFailureWithChat,
  isOnfidoChecksStatus,
  hasValidatedOnfido,
  accountId,
  onfidoApplicantId,
  verificationUuid,
  welcomeFields,
  addressFields,
  selectedPromo
}) => {
  const [hasCreatedCheck, setHasCreatedCheck] = useState(false);
  const [hasStartedPoller, setHasStartedPoller] = useState(false);
  const [checkId, setCheckId] = useState("");

  const onfidoFailStatus = showOnfidoFailureWithChat
    ? "onfidoChecksErrorWithChat"
    : "onfidoChecksError";

  useEffect(() => {
    if (
      !hasCreatedCheck &&
      isOnfidoChecksStatus &&
      hasValidatedOnfido &&
      accountId &&
      onfidoApplicantId &&
      verificationUuid
    ) {
      uamService
        .postOnfidoCheck({
          accountId,
          onfidoApplicantId,
          verificationUuid
        })
        .then(({ data }) => {
          setHasCreatedCheck(true);
          const onfidoCheckId = get(data, "onfidoCheckId", "");
          setCheckId(onfidoCheckId);
        })
        .catch(() => {
          dispatch(
            handleErrorModalRegistrationAction({
              isOpen: true,
              status: onfidoFailStatus
            })
          );
        });
    }
    // Create poller to UAM GET /users/{accountId}/onfido-check/{checkId}
  }, [hasValidatedOnfido, accountId, onfidoApplicantId, verificationUuid]);

  const [showDelayedText, setShowDelayedText] = useState(false);

  useEffect(() => {
    const isPollerRunning = checksPoller.isRunning();

    if (checkId && accountId && !hasStartedPoller && !isPollerRunning) {
      setHasStartedPoller(true);

      // Initiate poller
      checksPoller.start(() => {
        counter += COUNTER_INCREMENT;

        if (counter >= COUNTER_CHECK) {
          setShowDelayedText(true);
        }

        onfidoPollerCallback({
          poller: checksPoller,
          dispatch,
          onfidoFailStatus,
          accountId,
          checkId,
          welcomeFields,
          addressFields,
          selectedPromo
        });
      }, POLLER_INTERVAL);
    }
  }, [checkId, accountId, hasStartedPoller]);

  useEffect(() => {
    if (
      checkId &&
      accountId &&
      hasStartedPoller &&
      checksPoller.isRunning() &&
      showDelayedText
    ) {
      setHasStartedPoller(true);

      checksPoller.stop();

      // Initiate poller
      checksPoller.start(() => {
        onfidoPollerCallback({
          poller: checksPoller,
          dispatch,
          onfidoFailStatus,
          accountId,
          checkId,
          welcomeFields,
          addressFields,
          selectedPromo
        });
      }, POLLER_EXTENDED_INTERVAL);
    }
  }, [checkId, accountId, hasStartedPoller, showDelayedText]);

  return [showDelayedText];
};
